import { render } from "./RegisterFormComponent.vue?vue&type=template&id=77f75b03&scoped=true"
import script from "./RegisterFormComponent.vue?vue&type=script&lang=js"
export * from "./RegisterFormComponent.vue?vue&type=script&lang=js"

import "./RegisterFormComponent.vue?vue&type=style&index=0&id=77f75b03&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f75b03"]])

export default __exports__